// ─── Post-account step IDs ──────────────────────────────────────────────

const BackendTrackedSteps = {
  InitActivation: 'init_activation',
  HowIsIntegrated: 'how_is_integrated',
  TaxesDescription: 'taxes_description',
  AccIbanOnInvoices: 'acc_iban_on_invoices',
  IssueCard: 'issue_card',
  CardToWallet: 'card_to_wallet',
  TopUp: 'top_up',
  ReadyToGo: 'ready_to_go',
} as const;

const LocalOnlySteps = {
  CardDesign: 'card_design',
  YourCardReady: 'your_card_ready',
} as const;

export const PostAccountStepId = {
  ...BackendTrackedSteps,
  ...LocalOnlySteps,
} as const;

// ─── Types ──────────────────────────────────────────────────────────────

export type SwanActivationStepIdType =
  typeof BackendTrackedSteps[keyof typeof BackendTrackedSteps];

type PostAccountStepIdType =
  typeof PostAccountStepId[keyof typeof PostAccountStepId];

// ─── Arrays ─────────────────────────────────────────────────────────────

const ALL_ACTIVATION_STEP_IDS: readonly PostAccountStepIdType[] =
  Object.values(PostAccountStepId);

// ─── Helpers ────────────────────────────────────────────────────────────

export const isValidActivationStepId = (
  stepId: string,
): stepId is PostAccountStepIdType => {
  return ALL_ACTIVATION_STEP_IDS.includes(stepId as PostAccountStepIdType);
};
